import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../helpers/reducerRegistry'
import { SCORE_TYPE } from '../../../../common/header/companyInfo/constant'
import {
  handleScoreDataTable,
  handleTableScoreHeader,
  handleTableScoreIds,
} from '../../../helpers'
import { getScore } from './thunk'

const slice = createSlice({
  name: 'companyAnalysis/peerAnalysis/score',
  initialState: {
    isLoading: false,
    creditRiskDataTable: {},
    performanceDataTable: {},
    ids: [],
    headers: [],
    listChartScore: [],
    activeTab: SCORE_TYPE.CREDIT_RISK,
  },
  reducers: {
    changeActiveTab: (state, action) => {
      state.activeTab = action.payload
    },
    changeListChartScore: (state, { payload }) => {
      state.listChartScore = payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getScore.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getScore.fulfilled, (state, { payload = [] }) => {
      state.isLoading = false
      if (payload.length) {
        state.ids = handleTableScoreIds(payload)
        state.headers = handleTableScoreHeader(payload[0])
        state.creditRiskDataTable = handleScoreDataTable(
          payload,
          state.ids,
          state.headers,
          'creditRiskScore',
        )
        state.performanceDataTable = handleScoreDataTable(
          payload,
          state.ids,
          state.headers,
          'performanceScore',
        )
      }
    })
    builder.addCase(getScore.rejected, (state, action) => {
      state.isLoading = action.payload.isLoading
    })
  },
})

export const selectScoreIds = (state) => state[slice.name].ids
export const selectScoreTableHeader = (state) => state[slice.name].headers
export const selectScoreIsLoading = (state) => state[slice.name].isLoading
export const selectListChartScore = (state) => state[slice.name].listChartScore
export const selectCreditRiskDataTable = (state) =>
  state[slice.name].creditRiskDataTable
export const selectPerformanceDataTable = (state) =>
  state[slice.name].performanceDataTable
export const selectActiveTab = (state) => state[slice.name].activeTab
export const selectCreditRiskDataItem = (rowId, colId) => (state) =>
  state[slice.name].creditRiskDataTable[rowId][colId]
export const selectPerformanceDataItem = (rowId, colId) => (state) =>
  state[slice.name].performanceDataTable[rowId][colId]

export const { changeActiveTab, changeListChartScore } = slice.actions

register(slice.name, slice.reducer)
